export class DeviceTabLog {
  timestamp: string;
  emitter: string;
  logLevel: string;
  eventType: string;
  message: string;
}
